module.exports = {
      id: "recipe-share-mail-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#recipe-share-mail",
      toString: function () {
        return this.url;
      }
    }